<template>
  <framed-table class="cst-table" v-if="rows.length">
      <thead>
      <tr>
        <th style="width:36px">
          <input type="checkbox" :checked="allOnPageSelected" v-on:change="togglePage">
        </th>
        <th>Nome da empresa</th>
        <th style="width:180px">CNPJ</th>
        <th style="width:120px">ID</th>
        <th style="width:110px">Banco</th>
        <th style="width:44px"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row in pageRows" :key="keyOf(row)" :class="{ 'is-selected': isSelected(row) }">
        <td><input type="checkbox" :checked="isSelected(row)" v-on:change="toggle(row)"></td>
        <td>{{ row.name }}</td>
        <td>{{ row.cnpj }}</td>
        <td>{{ row.code || row.companyId }}</td>
        <td>{{ row.contextCode }}</td>
        <td class="cst-remove">
          <i class="fa fa-trash" aria-hidden="true"
             v-if="isSelected(row)"
             v-tooltip.top-center="{ content: 'Remover da seleção', classes: 'bc-tooltip' }"
             v-on:click="$emit('remove', row)"></i>
        </td>
      </tr>
      </tbody>

    <table-pager slot="footer" :total="rows.length" :page.sync="page" :page-size="pageSize"
                 @update:pageSize="changePageSize"/>
  </framed-table>
</template>

<script>
import framedTable from '../../components/default/framedTable.vue';
import tablePager from '../../components/default/tablePager.vue';
import {
  browserStorage, clampPage, pageSlice, readPageSize, writePageSize,
} from '../../components/default/pagination';

const STORAGE_KEY = 'company-selection';

/**
 * Tabela de empresas resolvidas, com selecao por linha e por pagina, lixeira
 * na linha selecionada e paginacao local (o mesmo rodape das outras tabelas,
 * mas comecando em 50: escolher empresas em lista longa de 10 em 10 cansa).
 * Nao usa `paged-table` porque o "marcar a pagina" do cabecalho precisa das
 * linhas da pagina aqui no script. Usada no passo 2 de Avisos e
 * Campanhas e na nova liberacao de funcionalidade.
 *
 * `rows`: empresas vindas de BROADCAST_RESOLVE_COMPANIES.
 * `selected` (.sync): subconjunto escolhido; a tabela emite `update:selected`
 * com um array NOVO a cada mudanca, nunca muta o do pai.
 * `remove`: a lixeira so avisa. O pai decide o que mais sai junto (a linha da
 * tabela, o termo do campo de busca).
 */
export default {
  name: 'company-selection-table',
  components: { framedTable, tablePager },
  props: {
    rows: { type: Array, required: true },
    selected: { type: Array, required: true },
  },
  data() {
    return { page: 1, pageSize: readPageSize(browserStorage(), STORAGE_KEY, 50) };
  },
  computed: {
    pageRows() {
      return pageSlice(this.rows, this.page, this.pageSize);
    },
    allOnPageSelected() {
      return (
        this.pageRows.length > 0 &&
        this.pageRows.every((row) => this.isSelected(row))
      );
    },
  },
  watch: {
    // Lista nova (outra busca) volta para a primeira pagina; lista que
    // encolheu (lixeira) so recua o que for preciso para nao ficar vazia.
    rows(next, prev) {
      if (next.length > prev.length) this.page = 1;
      this.page = clampPage(this.page, next.length, this.pageSize);
    },
  },
  methods: {
    changePageSize(size) {
      this.pageSize = size;
      this.page = 1;
      writePageSize(browserStorage(), STORAGE_KEY, size);
    },
    keyOf(row) {
      // Id de empresa e unico POR BANCO, nao globalmente: a chave precisa do
      // contexto junto, senao duas empresas de shards diferentes colidem.
      return row.contextCode + ':' + row.companyId;
    },
    isSelected(row) {
      const key = this.keyOf(row);
      return this.selected.some((item) => this.keyOf(item) === key);
    },
    toggle(row) {
      const key = this.keyOf(row);
      const next = this.selected.filter((item) => this.keyOf(item) !== key);
      if (next.length === this.selected.length) next.push(row);
      this.$emit('update:selected', next);
    },
    togglePage() {
      const keys = this.pageRows.map((row) => this.keyOf(row));
      if (this.allOnPageSelected) {
        this.$emit('update:selected',
          this.selected.filter((item) => keys.indexOf(this.keyOf(item)) === -1));
        return;
      }
      const next = this.selected.slice();
      this.pageRows.forEach((row) => {
        if (!this.isSelected(row)) next.push(row);
      });
      this.$emit('update:selected', next);
    },
  },
};
</script>

<style scoped>
/* Mesma moldura das listas (framedTable); aqui so o respiro do resumo acima. */
.cst-table { margin-top: 10px; }
.cst-remove { text-align: center; }
.cst-remove i { color: #ff445d; cursor: pointer; }
/* `>>>`: a linha e renderizada pelo slot, dentro do escopo do framedTable. */
.cst-table >>> tr.is-selected { background: #edf2fe !important; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/companySelectionTable.vue